/* tslint:disable */
import { Equipment } from './equipment';
import { ViewStudyEquipment } from './view-study-equipment';
import { TempExt } from './temp-ext';
import { EquipGeneration } from './equip-generation';

/**
 */
export class ViewOperatingSetting {
    equipments?: Equipment;
    studyEquipment?: ViewStudyEquipment;
    resultTempExts?: TempExt;
    equipGeneration?: EquipGeneration;
    changeTr?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-operating-setting.ts